"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var url_manager_1 = __importDefault(require("~/util/url_manager"));
var review_start_class_name_1 = require("~/util/review_start_class_name");
var CO_CATS_DISPLAY_COUNT = 2;
var PinInformation = function (_a) {
    var store = _a.store;
    var reviewStartClass = (0, classnames_1.default)("review__stars", "xs", (0, review_start_class_name_1.reviewStarClassName)(store.rating));
    var formattedRating = new Intl
        .NumberFormat("ja-JP", { minimumFractionDigits: 1 })
        .format(store.rating);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "mapsLocationsGoogleMap-PinInformation_StoreName" }, store.name),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: reviewStartClass }),
            react_1.default.createElement("span", { className: "mapsLocationsGoogleMap-PinInformation_Rating" }, formattedRating),
            react_1.default.createElement("span", { className: "mapsLocationsGoogleMap-PinInformation_ReviewCount" },
                "(",
                store.review_count,
                ")")),
        react_1.default.createElement("div", null, store.address),
        react_1.default.createElement("div", { className: "mapsLocationsGoogleMap-PinInformation_CoCatsContainer" },
            react_1.default.createElement("span", null, "\u53D6\u6271\u5546\u54C1\uFF1A"),
            react_1.default.createElement("span", null, lodash_1.default.take(store.co_cats, CO_CATS_DISPLAY_COUNT).join("、")),
            store.co_cats.length > CO_CATS_DISPLAY_COUNT &&
                react_1.default.createElement("span", { className: "mapsLocationsGoogleMap-PinInformation_MoreCoCatsLabel" },
                    "(\u4ED6",
                    store.co_cats.length - CO_CATS_DISPLAY_COUNT,
                    "\u7A2E\u985E\u306E\u53D6\u6271\u5546\u54C1)")),
        react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: url_manager_1.default.getStoreUrl(store.id), target: "_blank", rel: "nopener noreferrer" }, "\u696D\u8005\u8A73\u7D30\u3078"))));
};
exports.default = PinInformation;
